export default () => document.documentElement.getAttribute('dir') === 'rtl';
